import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface MecsError {
  errorMessage: string;
  cylinderName: string;
  keyway: string;
  shearline: string;
  keyName: string;
  keySection: string;
  bitting: string;
  operatedBy: string;
}

export interface MecsErrorsDialogData {
  title: string;
  errorString: string;
}

@Component({
  selector: 'app-mecs-errors-dialog',
  templateUrl: './mecs-errors-dialog.component.html',
  styleUrls: ['./mecs-errors-dialog.component.scss'],
  standalone: false
})
export class MecsErrorsDialogComponent implements OnInit {
  parsedErrors: MecsError[] = [];
  displayedColumns: string[] = ['errorMessage', 'cylinderName', 'keyway', 'shearline', 'keyName', 'keySection', 'bitting', 'operatedBy'];

  constructor(
    private dialogRef: MatDialogRef<MecsErrorsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MecsErrorsDialogData
  ) {}

  ngOnInit(): void {
    this.parseErrors();
  }

  private parseErrors(): void {
    if (!this.data.errorString) {
      this.parsedErrors = [];
      return;
    }

    // Split by semicolon to get individual errors
    const errorStrings = this.data.errorString.split(';').filter(s => s.trim());

    this.parsedErrors = errorStrings.map(errorStr => {
      const error: MecsError = {
        errorMessage: '',
        cylinderName: '',
        keyway: '',
        shearline: '',
        keyName: '',
        keySection: '',
        bitting: '',
        operatedBy: ''
      };

      // Split by pipe to get individual fields
      const fields = errorStr.split('|').map(f => f.trim());

      fields.forEach(field => {
        // Split by first colon to get key and value
        const colonIndex = field.indexOf(':');
        if (colonIndex === -1) return;

        const key = field.substring(0, colonIndex).trim().toLowerCase();
        const value = field.substring(colonIndex + 1).trim();

        switch (key) {
          case 'error message':
            error.errorMessage = value;
            break;
          case 'cylinder name':
            error.cylinderName = value;
            break;
          case 'keyway':
            error.keyway = value;
            break;
          case 'shearline':
            error.shearline = value;
            break;
          case 'key name':
            error.keyName = value;
            break;
          case 'keysection':
            error.keySection = value;
            break;
          case 'bitting':
            error.bitting = value;
            break;
          case 'operated by':
            error.operatedBy = value;
            break;
        }
      });

      return error;
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
